import React, { useState, useEffect } from "react";
import { BsCart2 } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { TbLayoutDashboardFilled } from "react-icons/tb";
import { IoIosPaper } from "react-icons/io";
import { MdOutlineAccountCircle } from "react-icons/md";
import { IoMdLogOut } from "react-icons/io";
import config from "../../config";
import { HiUsers } from "react-icons/hi";
import { FaUser, FaKey, FaWallet } from "react-icons/fa";
import { IoSettingsSharp } from "react-icons/io5";
import TopBar from './TopBar';
import { useLanguage } from '../../context/LanguageContext';
import { useCurrency } from '../../context/CurrencyContext';

export default function Header() {
    const navigate = useNavigate();
    const [logoutLoading, setLogoutLoading] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [drop, setDrop] = useState(false);
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const [cartCount, setCartCount] = useState(0);

    const [isDarkMode, setIsDarkMode] = useState(() => {
        return localStorage.getItem("darkMode") === "enabled";
    });
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        const themeClass = isDarkMode ? "dark-mode" : "light-mode";
        document.documentElement.className = themeClass;
        localStorage.setItem("darkMode", isDarkMode ? "enabled" : "disabled");
    }, [isDarkMode]);
    const toggleTheme = (mode) => {
        setIsDarkMode(mode);
    };
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 991);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleClick = () => {
        setDrop(!drop);
    }

    useEffect(() => {
        const today = new Date();
        today.setDate(today.getDate() + 3);
        const formattedToday = today.toISOString().split('T')[0];

        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        const formattedTomorrow = tomorrow.toISOString().split('T')[0];
        setStartDate(formattedToday);
        setEndDate(formattedTomorrow);

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 700);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleLogout = async () => {
        if (userData && userData.token) {
            setLogoutLoading(true)
            try {
                await axios.post(`${config.API_BASE_URL_V1}auth/logout`, {}, {
                    headers: {
                        Authorization: `Bearer ${userData.token}`, 
                    },
                });
                // Sadece ilgili verileri temizle
                localStorage.removeItem('user_data');
                localStorage.removeItem('is_agency_user');
                localStorage.removeItem('is_hotel_user');
                window.location.href = '/login'; // Logout başarılı, yönlendir
            } catch (error) {
                console.error('Logout error:', error.response?.data || error.message || 'Bilinmeyen bir hata oluştu.');
            }
            finally
            {
                setLogoutLoading(false);
            }
        } else {
            // Token yoksa doğrudan yönlendir
            window.location.href = '/login';
        }
    };
    
    const handleSubmitHotels = () => {
        const params = new URLSearchParams();
        
        // Temel parametreleri ekle
        params.set('checkIn', startDate);
        params.set('checkOut', endDate);
        params.set('nation', 'SA');
        params.set('lat', '41.0168639'); // İstanbul merkezi koordinatları
        params.set('lng', '28.9470422');
        params.set('lang', 'ENG');
        params.set('sourcemarket', 'SA');
        params.set('locationName', 'Fatih/İstanbul, Türkiye');

        // Occupancies bilgisini ekle
        const occupancies = [{
            rooms: 1,
            adults: 2,
            children: 0,
            paxes: []
        }];
        console.log('OCC2: ', occupancies);
        
        // Occupancies'i JSON string olarak URL'e ekle
        params.set('occupancies', JSON.stringify(occupancies));
        // Hotels sayfasına yönlendir
        navigate(`/hotels?${params.toString()}`);
        window.scrollTo(0, 0);
    };
    
    const { currentLanguage, setCurrentLanguage } = useLanguage();

    const languages = [
        { code: 'en', name: 'ENG', flag: '/assets/img/flags/us-flag.svg' },
        { code: 'tr', name: 'TUR', flag: '/assets/img/flags/tr-flag.svg' },
    ];

    const getCurrentLanguageInfo = () => {
        return languages.find(lang => lang.code === currentLanguage) || languages[0];
    };

    const handleLanguageChange = (langCode) => {
        setCurrentLanguage(langCode);
    };

    const currentLang = getCurrentLanguageInfo();

    const { selectedCurrency, setSelectedCurrency, exchangeRates, loading } = useCurrency();

    useEffect(() => {
        const fetchBasket = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL_V1}basket`, {
                    headers: {
                        Authorization: `Bearer ${userData?.token}`,
                    },
                });
                
                if (response.data.status === "success" && response.data.data.basket) {
                    setCartCount(response.data.data.basket.basketItems.length);
                }
            } catch (error) {
                console.error('Basket fetch error:', error);
            }
        };

        if (userData?.token) {
            fetchBasket();
        }
    }, [userData?.token]);

    return (
        <>
            <div className="main-header">
                <div className="header-topbar bg-transparent text-center">
                    <div className="container">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <p className="d-flex align-items-center fw-medium fs-14 mb-2">
                                <i className="isax isax-call5 me-2"></i>Toll Free : +90 212 533 31 22
                            </p>
                            <div className="d-flex align-items-center">
                                <p className="d-flex align-items-center fw-medium fs-14 mb-2 me-3">
                                    <i className="isax isax-message-text-15 me-2"></i>Email : info@cornleth.com
                                </p>
                                <div className="dropdown flag-dropdown mb-2 me-3">
                                    <a href="javascript:void(0);" 
                                       className="dropdown-toggle d-inline-flex align-items-center" 
                                       data-bs-toggle="dropdown" 
                                       aria-expanded="false"
                                    >
                                        <img src={currentLang.flag} className="me-2 text-white" alt="flag" />
                                        {currentLang.name}
                                    </a>
                                    <ul className="dropdown-menu p-2 mt-2">
                                        {languages.map((lang) => (
                                            <li key={lang.code}>
                                                <a 
                                                    className="dropdown-item rounded d-flex align-items-center" 
                                                    href="javascript:void(0);"
                                                    onClick={() => handleLanguageChange(lang.code)}
                                                >
                                                    <img src={lang.flag} className="me-2 text-white" alt="flag" />
                                                    {lang.name}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="dropdown mb-2 me-3">
                                    <a className="dropdown-toggle d-flex align-items-center currency-selector" 
                                       data-bs-toggle="dropdown" 
                                       aria-expanded="false"
                                       style={{ 
                                           cursor: loading ? 'wait' : 'pointer',
                                           padding: '6px 12px',
                                           borderRadius: '20px',
                                           backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                           transition: 'all 0.3s ease',
                                           fontSize: '14px',
                                           fontWeight: '500',
                                           color: 'white'
                                       }}
                                    >
                                        <span className="currency-icon me-1">
                                            {selectedCurrency === 'EUR' && '€'}
                                            {selectedCurrency === 'USD' && '$'}
                                            {selectedCurrency === 'TRY' && '₺'}
                                        </span>
                                        {selectedCurrency}
                                        {loading ? (
                                            <div className="ms-2 spinner-border spinner-border-sm" 
                                                 role="status"
                                                 style={{ width: '14px', height: '14px', borderWidth: '2px' }}
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        ):(
                                            <i className="isax isax-arrow-down-1 ms-2" style={{ fontSize: '12px' }}></i>
                                        )}
                                    </a>
                                    <ul className="dropdown-menu p-2 mt-2" style={{
                                        minWidth: '180px',
                                        borderRadius: '12px',
                                        border: '1px solid rgba(0,0,0,0.08)',
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.05)'
                                    }}>
                                        <li>
                                            <a 
                                                className={`dropdown-item rounded d-flex align-items-center justify-content-between ${selectedCurrency === 'EUR' ? 'active' : ''}`} 
                                                href="javascript:void(0);" 
                                                onClick={() => !loading && selectedCurrency !== 'EUR' && setSelectedCurrency('EUR')}
                                                style={{ 
                                                    cursor: loading ? 'wait' : 'pointer',
                                                    padding: '10px 15px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <span className="d-flex align-items-center">
                                                    <span className="currency-symbol me-2">€</span>
                                                    <span>EUR</span>
                                                </span>
                                                {exchangeRates?.EUR?.Buying && (
                                                    <span className="rate-info" style={{ 
                                                        fontSize: '12px',
                                                        color: '#666',
                                                        fontWeight: '500'
                                                    }}>
                                                        {parseFloat(exchangeRates.EUR.Buying).toFixed(2)}
                                                    </span>
                                                )}
                                            </a>
                                        </li>
                                        <li>
                                            <a 
                                                className={`dropdown-item rounded d-flex align-items-center justify-content-between ${selectedCurrency === 'USD' ? 'active' : ''}`} 
                                                href="javascript:void(0);" 
                                                onClick={() => !loading && selectedCurrency !== 'USD' && setSelectedCurrency('USD')}
                                                style={{ 
                                                    cursor: loading ? 'wait' : 'pointer',
                                                    padding: '10px 15px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <span className="d-flex align-items-center">
                                                    <span className="currency-symbol me-2">$</span>
                                                    <span>USD</span>
                                                </span>
                                                {exchangeRates?.USD?.Buying && (
                                                    <span className="rate-info" style={{ 
                                                        fontSize: '12px',
                                                        color: '#666',
                                                        fontWeight: '500'
                                                    }}>
                                                        {parseFloat(exchangeRates.USD.Buying).toFixed(2)}
                                                    </span>
                                                )}
                                            </a>
                                        </li>
                                        <li>
                                            <a 
                                                className={`dropdown-item rounded d-flex align-items-center justify-content-between ${selectedCurrency === 'TRY' ? 'active' : ''}`} 
                                                href="javascript:void(0);" 
                                                onClick={() => !loading && selectedCurrency !== 'TRY' && setSelectedCurrency('TRY')}
                                                style={{ 
                                                    cursor: loading ? 'wait' : 'pointer',
                                                    padding: '10px 15px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <span className="d-flex align-items-center">
                                                    <span className="currency-symbol me-2">₺</span>
                                                    <span>TRY</span>
                                                </span>
                                                <span className="rate-info" style={{ 
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    fontWeight: '500'
                                                }}>
                                                    1.00
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <a href='/cart' className='button -sm -outline-dark-1 d-flex flex-row align-items-center mb-2 me-3' 
                                   style={{ 
                                       textAlign:'center', 
                                       justifyContent:'center', 
                                       cursor:'pointer', 
                                       padding: '6px 12px',
                                       borderRadius: '20px',
                                       backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                       transition: 'all 0.3s ease',
                                       fontSize: '14px',
                                       fontWeight: '500',
                                       color: 'white'
                                   }}>
                                    <BsCart2 style={{ fontSize:'18px', marginRight: '8px' }}/> 
                                    <div style={{ 
                                        backgroundColor: '#ff4444', 
                                        borderRadius: '50%', 
                                        padding: '2px 6px', 
                                        color: 'white', 
                                        fontSize: '12px', 
                                        fontWeight: '500' 
                                    }}>
                                        {cartCount || 0}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <header>
                    <div className="container">
                        <div className={`offcanvas-info ${isMenuOpen ? "show" : ""}`}>
                            <div className="offcanvas-wrap">
                                <div className="offcanvas-detail">
                                    <div className="offcanvas-head" style={{ borderBottom:'solid', borderColor:'lightgray' }}>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <a href="/" className="black-logo-responsive">
                                                <img src="/assets/logo-1.png" style={{ width:'200px' }} alt="logo-img"/>
                                            </a>
                                            <a href="/" className="white-logo-responsive">
                                                <img src="/assets/logo-1.png" style={{ width:'200px' }} alt="logo-img"/>
                                            </a>
                                            <div onClick={toggleMenu} className="offcanvas-close">
                                                <i className="ti ti-x"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginBlock:'50px', marginLeft:'20px' }} >
                                        <ul className="d-flex flex-column" style={{ gap:'20px' }}>
                                            <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                <a href="/"><i className="isax isax-home5 me-2"></i>Home</a>
                                            </li>
                                            <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                <a href="/about"><i className="isax isax-info-circle me-2"></i>About</a>
                                            </li>
                                            <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                <a href="/contact"><i className="isax isax-call me-2"></i>Contact</a>
                                            </li>
                                            <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                <a href="/cart"><BsCart2 className="me-2" /> Cart ({cartCount || 0})</a>
                                            </li>
                                            {userData && (
                                                <>
                                                    <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                        <a href="/dashboard"><TbLayoutDashboardFilled className="me-2" /> Dashboard</a>
                                                    </li>
                                                    <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                        <a href="/dashboard-bookings"><IoIosPaper className="me-2" /> Bookings</a>
                                                    </li>
                                                    <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                        <a href="/dashboard-settings"><MdOutlineAccountCircle className="me-2" /> Account</a>
                                                    </li>
                                                    <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                        <a href="/dashboard-users"><HiUsers className="me-2" /> Users</a>
                                                    </li>
                                                    <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                        <a href="/dashboard-sub-agency"><HiUsers className="me-2" /> Sub Agencies</a>
                                                    </li>
                                                    <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                        <a href="/dashboard-credit"><FaWallet className="me-2" /> Credit / Credit Card</a>
                                                    </li>
                                                    <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                        <a href="/dashboard-settings"><IoSettingsSharp className="me-2" /> Company Settings</a>
                                                    </li>
                                                    <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                        <a href="/dashboard-profile"><FaUser className="me-2" /> Profile Management</a>
                                                    </li>
                                                    {
                                                        userData.user.isOwner == false && (
                                                            <li style={{ fontWeight:'bold', fontSize:'15px' }}>
                                                                <a href="/dashboard-representative-user"><FaUser className="me-2" /> Representative User</a>
                                                            </li>
                                                        )
                                                    }
                                                </>
                                            )}
                                        </ul>
                                    </div>
                                    <div className="offcanvas__contact">
                                        <div className="mt-4">
                                            <div>
                                                {userData ? (
                                                    <a onClick={() => handleLogout()} className="btn btn-dark w-100 mb-3 text-white"> 
                                                        {logoutLoading ? 'Loading...' : 'Logout'}
                                                    </a>
                                                ) : (
                                                    <a href="/login" className="btn btn-dark w-100 mb-3 text-white">Login</a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="offcanvas-overlay"></div>
                        <div className="header-nav">
                            <div className="main-menu-wrapper">
                                <div className="navbar-logo">
                                    <a className="logo-white header-logo" href="/">
                                        <img src="/assets/logo-1-white.png" style={{ width:'200px' }} className="logo" alt="Logo"/>
                                    </a>
                                    <a className="logo-dark header-logo" href="/">
                                        <img src="/assets/logo-1.png" style={{ width:'200px' }} className="logo" alt="Logo"/>
                                    </a>
                                </div>
                                <nav id="mobile-menu" style={{ display: isMobile ? "none" : "block" }}>
                                    <ul className="main-nav">
                                        <li className=" megamenu">
                                            <a href="/">Home</a>
                                        </li>
                                        <li className=" mega-innermenu">
                                            <a href="/about">About</a>
                                        </li>
                                        <li className=" mega-innermenu">
                                            <a onClick={() => handleSubmitHotels()}>Hotels</a>
                                        </li>
                                        <li className=" mega-innermenu">
                                            <a href="/contact">Contact</a>
                                        </li>
                                    </ul>
                                </nav>
                                <div onClick={toggleMenu} className="header-btn d-flex align-items-center">
                                    <div className="me-3">
                                        <a href="javascript:void(0);" id="dark-mode-toggle" className="theme-toggle">
                                            <i className="isax isax-moon"></i>
                                        </a>
                                        <a href="javascript:void(0);" id="light-mode-toggle" className="theme-toggle">
                                            <i className="isax isax-sun-1"></i>
                                        </a>
                                    </div>

                                    

                                    <div className="header__hamburger d-xl-none my-auto">
                                        <div className="sidebar-menu">
                                            <i className="isax isax-menu5"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="test" style={{ display: isMobile ? "none" : "block" }}>
                                    {userData ? (
                                            <>
                                                <div className="user-info d-flex flex-row">
                                                    <a onClick={() => handleClick()} style={{ fontSize:'13px',cursor:'pointer', borderRadius:'12px', width:'160px' }} className="button btn btn-white -sm -outline-dark-1 text-dark-1 ml-30">{userData.user.name} {userData.user.surname}</a>
                                                    {drop && (
                                                        <div className="dropdown" style={{width: '160px',backgroundColor: 'whitesmoke',borderRadius: '12px',boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',marginTop: '2%',position: 'absolute',top: '40px',zIndex: 10,}}>
                                                            <div className="d-flex flex-column" style={{padding: '10px',}}>
                                                                <p onClick={() => navigate('/dashboard')} style={{fontSize:'13px',cursor: 'pointer',color: '#333',margin: '5px 0',transition: 'color 0.3s',fontWeight: '500',backgroundColor:'white', padding:'5px', borderRadius:'5px' }} onMouseEnter={(e) =>(e.target.style.color = '#007BFF')} onMouseLeave={(e) =>(e.target.style.color = '#333')}> <TbLayoutDashboardFilled /> Dashboard</p>
                                                                <p onClick={() => navigate('/dashboard-bookings')} style={{fontSize:'13px',cursor: 'pointer',color: '#333',paddingBottom: '10px',margin: '5px 0',transition: 'color 0.3s',fontWeight: '500',backgroundColor:'white', padding:'5px', borderRadius:'5px'}} onMouseEnter={(e) =>(e.target.style.color = '#007BFF')} onMouseLeave={(e) =>(e.target.style.color = '#333')}> <IoIosPaper /> Bookings</p>
                                                                <p onClick={() => navigate('/dashboard-settings')}style={{fontSize:'13px',cursor: 'pointer',color: '#333',paddingBottom: '10px',margin: '5px 0',transition: 'color 0.3s',fontWeight: '500',backgroundColor:'white', padding:'5px', borderRadius:'5px'}} onMouseEnter={(e) =>(e.target.style.color = '#007BFF')} onMouseLeave={(e) =>(e.target.style.color = '#333')}> <MdOutlineAccountCircle /> Account</p>
                                                                <p onClick={() => navigate('/dashboard-users')}style={{fontSize:'13px',cursor: 'pointer',color: '#333',paddingBottom: '10px',margin: '5px 0',transition: 'color 0.3s',fontWeight: '500',backgroundColor:'white', padding:'5px', borderRadius:'5px'}} onMouseEnter={(e) =>(e.target.style.color = '#007BFF')} onMouseLeave={(e) =>(e.target.style.color = '#333')}> <HiUsers /> Users</p>
                                                                <p onClick={() => navigate('/dashboard-sub-agency')}style={{fontSize:'13px',cursor: 'pointer',color: '#333',paddingBottom: '10px',margin: '5px 0',transition: 'color 0.3s',fontWeight: '500',backgroundColor:'white', padding:'5px', borderRadius:'5px'}} onMouseEnter={(e) =>(e.target.style.color = '#007BFF')} onMouseLeave={(e) =>(e.target.style.color = '#333')}> <HiUsers /> Sub Agencies</p>
                                                                <p onClick={() => navigate('/dashboard-credit')}style={{fontSize:'13px',cursor: 'pointer',color: '#333',paddingBottom: '10px',margin: '5px 0',transition: 'color 0.3s',fontWeight: '500',backgroundColor:'white', padding:'5px', borderRadius:'5px'}} onMouseEnter={(e) =>(e.target.style.color = '#007BFF')} onMouseLeave={(e) =>(e.target.style.color = '#333')}> <FaWallet /> Credit / Credit Card</p>
                                                                <p onClick={() => navigate('/dashboard-settings')}style={{fontSize:'13px',cursor: 'pointer',color: '#333',paddingBottom: '10px',margin: '5px 0',transition: 'color 0.3s',fontWeight: '500',backgroundColor:'white', padding:'5px', borderRadius:'5px'}} onMouseEnter={(e) =>(e.target.style.color = '#007BFF')} onMouseLeave={(e) =>(e.target.style.color = '#333')}> <IoSettingsSharp /> Company Settings</p>
                                                                <p onClick={() => navigate('/dashboard-profile')}style={{fontSize:'13px',cursor: 'pointer',color: '#333',paddingBottom: '10px',margin: '5px 0',transition: 'color 0.3s',fontWeight: '500',backgroundColor:'white', padding:'5px', borderRadius:'5px'}} onMouseEnter={(e) =>(e.target.style.color = '#007BFF')} onMouseLeave={(e) =>(e.target.style.color = '#333')}> <FaUser /> Profile Management</p>
                                                                <p onClick={() => handleLogout()}style={{fontSize:'13px',cursor: 'pointer',color: 'red',paddingBottom: '10px',margin: '5px 0',fontWeight: '500',backgroundColor:'white', padding:'5px', borderRadius:'10px'}}> <IoMdLogOut style={{ color:'red' }}/> 
                                                                {
                                                                    logoutLoading == true ? 'Loading...' : 'Logout'
                                                                }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            <a href="/login" className="button -sm -outline-dark-1 rounded-200 text-dark-1 ml-30">
                                                Log in
                                            </a>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
            <style jsx>{`
                .currency-selector:hover {
                    background-color: rgba(255, 255, 255, 0.2) !important;
                }

                .dropdown-item {
                    color: #333 !important;
                }

                .dropdown-item:hover {
                    background-color: rgba(0, 123, 255, 0.05) !important;
                    transform: translateX(3px);
                    color: #007bff !important;
                }

                .dropdown-item.active {
                    background-color: rgba(0, 123, 255, 0.1) !important;
                    color: #007bff !important;
                }

                .currency-symbol {
                    font-weight: 600;
                }

                .rate-info {
                    opacity: 0.8;
                    color: #666 !important;
                }

                .dropdown-item:hover .rate-info {
                    opacity: 1;
                    color: #007bff !important;
                }

                .dropdown-menu {
                    background-color: #fff !important;
                }

                .dropdown-item:hover .currency-symbol {
                    color: #007bff !important;
                }
            `}</style>
        </>
    );
}
